import { render, staticRenderFns } from "./FormFlight.vue?vue&type=template&id=b86711f6&scoped=true&"
import script from "./FormFlight.vue?vue&type=script&lang=js&"
export * from "./FormFlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86711f6",
  null
  
)

export default component.exports